import React from 'react';

const PaginationPrevButton = ({ handlePagination, url }) => {
	return (
		<li className="mx-1">
			<a
				href={url}
				aria-label="Previous Page"
				onClick={(e) => {
					e.preventDefault();
					handlePagination(url);
				}}
				className="pagination__list-item-link text-cta-action"
				data-testid="pagination-prev">
				<div className="text-base">
					<i className="ico ico-chevron-left ico-lg text-cta-action" />
				</div>
			</a>
		</li>
	);
};

export default PaginationPrevButton;
